"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { cn } from "./lib/utils";

export function RotateSentences({
	values,
	duration,
	className,
}: {
	values: string[];
	duration: number;
	className?: string;
}): React.ReactElement | null {
	const [currentIndex, setCurrentIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentIndex((prev) => (prev + 1) % values.length);
		}, duration);

		return () => clearInterval(interval);
	}, [values, duration]);

	const text = values[currentIndex];
	const variants = {
		initial: {
			y: -6,
			opacity: 0,
			delay: 1,
		},
		enter: {
			y: 0,
			opacity: 1,
		},
		exit: {
			y: 6,
			opacity: 0,
		},
	};

	return (
		<div className="relative w-full h-[32px] flex flex-col items-center justify-center">
			<AnimatePresence mode="wait">
				<motion.div
					key={currentIndex}
					variants={variants}
					initial="initial"
					animate="enter"
					exit="exit"
					className={cn("absolute", className)}
					transition={{
						duration: 0.5,
						ease: "easeIn",
					}}
				>
					{text}
				</motion.div>
			</AnimatePresence>
		</div>
	);
}
